import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { RootState } from 'reducers';
import { MembershipService } from 'services';
import { Modal } from 'react-bootstrap';
import { Globals } from 'utils';

interface Props extends RootState {
  onClose?: any;
}

class RenewMembership extends React.Component<Props> {
  state = {
    plan: null,
    months: [],
    selectedMonths: [],
    total: 0,
    iva: 0,
    conversion: 0,
    payment_methods: [],
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await MembershipService.getPlanUser({
      user_id: this.props.user.id,
    });

    this.setState({
      months: res.months || [],
      plan: res.plan,
      iva: res.iva?.value || 0,
      conversion: res.conversion?.amount || 0,
      payment_methods: res.payment_methods || [],
    });
  };

  getTotal = () => {
    const subtotal = +this.state.total;
    const iva_total = subtotal * (this.state.iva / 100);
    const total = subtotal + iva_total;

    return {
      subtotal,
      iva_total,
      total,
    };
  };

  handleSelectMonth = (index: any) => {
    const { months, selectedMonths } = this.state;
    const plan: any = this.state.plan;
    const selectedMonth: any = months[index];
    const isNotValid = moment(selectedMonth.date).isBefore(
      moment().startOf('day'),
    );

    if (selectedMonth.pay || isNotValid) return;

    const selectedIndexInState = selectedMonths.findIndex(
      (date) => date === selectedMonth.date,
    );
    const isSelected = selectedIndexInState !== -1;

    let newSelectedMonths: any = [...selectedMonths];

    // Desmarcar si es el último seleccionado
    if (isSelected) {
      if (selectedMonths[selectedMonths.length - 1] === selectedMonth.date) {
        newSelectedMonths = selectedMonths.slice(0, -1);
      } else {
        return;
      }
    } else {
      if (selectedMonths.length === 0) {
        const firstSelectableIndex = months.findIndex((m: any) => !m.pay);
        if (index === firstSelectableIndex) {
          newSelectedMonths = [selectedMonth.date];
        } else {
          return;
        }
      } else {
        const lastSelectedDate = selectedMonths[selectedMonths.length - 1];
        const lastSelectedIndex = months.findIndex(
          (m: any) => m.date === lastSelectedDate,
        );
        if (index === lastSelectedIndex + 1 && !selectedMonth.pay) {
          newSelectedMonths = [...selectedMonths, selectedMonth.date];
        } else {
          return;
        }
      }
    }

    this.setState({
      selectedMonths: newSelectedMonths,
      total: (newSelectedMonths.length * plan?.membership.price_month).toFixed(
        2,
      ),
    });
  };

  submit = async () => {
    const { total } = this.getTotal();

    this.props.onClose?.call(this, true, {
      months: this.state.selectedMonths,
      mode: 'month',
      total: total,
    });
  };

  render() {
    const { months } = this.state;
    const selectedMonths: any = this.state.selectedMonths;
    const plan: any = this.state.plan;
    const { subtotal, iva_total, total } = this.getTotal();

    return (
      <div id="renew-membership">
        <Modal.Header closeButton>
          <div className="header">
            <Modal.Title>Cuotas</Modal.Title>
          </div>
        </Modal.Header>
        <div className="body">
          <p className="plan-name">{plan?.membership?.name}</p>

          <div className="header">
            <p>Fecha a vencer</p>
            <p>Método</p>
            <p>Monto</p>
          </div>

          <div className="months-list">
            {months.map((month: any, index: any) => {
              const isSelected = selectedMonths.includes(month.date);
              const isPaid = month.pay;
              const isNotValid = moment(month.date).isBefore(
                moment().startOf('day'),
              );
              const isDisabled = isPaid || isNotValid;

              return (
                <button
                  key={index}
                  onClick={() => this.handleSelectMonth(index)}
                  disabled={isDisabled}
                  className={`month-button ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                >
                  <div className="left">
                    <div
                      className={`circle ${isSelected ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
                    >
                      {isSelected && !isDisabled && (
                        <div className="dot green" />
                      )}
                      {isDisabled && <div className="dot gray" />}
                    </div>
                    <span>
                      {moment(month.date).format('DD-MMM').toUpperCase()}
                    </span>
                  </div>
                  <span className="amount">{month?.payment_method}</span>
                  <span className="amount">
                    {Globals.formatMiles(month?.amount)}
                  </span>
                </button>
              );
            })}
          </div>

          <div className="total">
            <p>Sub-total</p>
            <p>{Globals.formatMiles(subtotal)}</p>
          </div>

          <div className="total">
            <p>Iva</p>
            <p>{Globals.formatMiles(iva_total)}</p>
          </div>

          <div className="total">
            <p>Total</p>
            <p>{Globals.formatMiles(total)}</p>
          </div>

          <button
            className="pay-button"
            onClick={() => this.submit()}
            disabled={selectedMonths.length === 0}
          >
            <div className="paypal-logo"></div>
            <span>Pagar</span>
          </button>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(RenewMembership);
